var React = require('react');

function FlowerTulip (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M511.94 336.84C502 435 405.58 512 288.18 512h-64.34C106.44 512 10.07 435 .08 336.84-.86 327.72 7 320 16.14 320H63.4c63 0 119.82 22.23 160.61 57.92V256h64v121.92C328.8 342.23 385.62 320 448.62 320h47.26c9.19 0 16.98 7.72 16.06 16.84z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M224 256A128 128 0 0 1 96 128V32l80 48 81.15-80L336 80l80-48v96a128 128 0 0 1-128 128z","className":"fa-primary","key":2})]);
}

FlowerTulip.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = FlowerTulip;

FlowerTulip.default = FlowerTulip;
